import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Tools|Audit Queue';
const sharedProps: Pick<LocDef, 'htmlAllowed' | 'shared' | 'feature' | 'portal'> = {
	htmlAllowed: false,
	shared: false,
	feature: HubFeature.OtherRequirementUploadCandidateAccessAudits,
	portal: 'SP',
};

type SPAuditQueueLoc =
	| 'SPAuditQueueTitle'
	| 'SPAuditQueueTableTitle'
	| 'SPAuditQueueTableDue'
	| 'SPAuditQueueTableCreatedDate'
	| 'SPAuditQueueTableCandidateName'
	| 'SPAuditQueueTableIntendedPath'
	| 'SPAuditQueueTableEnrollment'
	| 'SPAuditQueueTableUserName'
	| 'SPAuditQueueTableStatus'
	| 'SPAuditQueueTableTableTitle'
	| 'SPAuditQueueTableAction'
	| 'SPAuditQueueTableViewAction'
	| 'SPAuditQueueTableAssignButtonLabel'
	| 'SPAuditQueueTableUnassignButtonLabel';

export const spAuditQueueLocs: LocDefs<SPAuditQueueLoc> = {
	SPAuditQueueTitle: {
		defaultValue: 'Sponsor Audit Queue',
		description: 'Page title and heading for the candidate history audit page.',
		displayPath: `${dpRoot}|Page Title`,
		displayType: 'Title',
		...sharedProps,
	},
	SPAuditQueueTableTitle: {
		defaultValue: 'Audits',
		description: 'Table title for the candidate audit list.',
		displayPath: `${dpRoot}|Table Title`,
		displayType: 'Title',
		...sharedProps,
	},
	SPAuditQueueTableDue: {
		defaultValue: 'Due Date',
		description: 'Table column header for the due date.',
		displayPath: `${dpRoot}|Due Date`,
		displayType: 'Label',
		...sharedProps,
	},
	SPAuditQueueTableCreatedDate: {
		defaultValue: 'Created Date',
		description: 'Table column header for the created date.',
		displayPath: `${dpRoot}|Created Date`,
		displayType: 'Label',
		...sharedProps,
	},
	SPAuditQueueTableCandidateName: {
		defaultValue: 'Candidate',
		description: 'Table column header for the candidate name.',
		displayPath: `${dpRoot}|Candidate Name`,
		displayType: 'Label',
		...sharedProps,
	},
	SPAuditQueueTableIntendedPath: {
		defaultValue: 'CE Intended Path',
		description: 'Table column header for the intended path.',
		displayPath: `${dpRoot}|Intended Path`,
		displayType: 'Label',
		...sharedProps,
	},
	SPAuditQueueTableEnrollment: {
		defaultValue: 'CE Enrollment',
		description: 'Table column header for the enrollment.',
		displayPath: `${dpRoot}|Enrollment`,
		displayType: 'Label',
		...sharedProps,
	},
	SPAuditQueueTableUserName: {
		defaultValue: 'Assignee',
		description: 'Table column header for the assignee.',
		displayPath: `${dpRoot}|Assignee`,
		displayType: 'Label',
		...sharedProps,
	},
	SPAuditQueueTableStatus: {
		defaultValue: 'Status',
		description: 'Table column header for the status.',
		displayPath: `${dpRoot}|Status`,
		displayType: 'Label',
		...sharedProps,
	},
	SPAuditQueueTableTableTitle: {
		defaultValue: 'Audit History',
		description: 'Table title for the candidate audit list.',
		displayPath: `${dpRoot}|Table Title`,
		displayType: 'Title',
		...sharedProps,
	},
	SPAuditQueueTableAction: {
		defaultValue: '',
		description: 'Table column header for the actions.',
		displayPath: `${dpRoot}|Action Column`,
		displayType: 'Label',
		...sharedProps,
	},
	SPAuditQueueTableViewAction: {
		defaultValue: 'View',
		description: 'View audit details action button.',
		displayPath: `${dpRoot}|View Action`,
		displayType: 'Button',
		...sharedProps,
	},
	SPAuditQueueTableAssignButtonLabel: {
		defaultValue: 'Assign/Reassign',
		description: 'Assign/Reassign button label.',
		displayPath: `${dpRoot}|Assign/Reassign Button Label`,
		displayType: 'Button',
		...sharedProps,
	},
	SPAuditQueueTableUnassignButtonLabel: {
		defaultValue: 'Unassign',
		description: 'Unassign button label.',
		displayPath: `${dpRoot}|Unassign Button Label`,
		displayType: 'Button',
		...sharedProps,
	},
};

export const spAuditQueueLocKeys = MapLocKeys<SPAuditQueueLoc>(spAuditQueueLocs);
export type SPAuditQueueLocKeys = typeof spAuditQueueLocKeys;
